// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"62e33bac","442":"19706764","895":"b7d3d9e0"}[chunkId] + ".chunk.js";
};